import React from 'react'

const DescriptionList = ({ data }) => {
    if (!data) return null;

    return (
        <div style={{
            margin: "12px 0px",
            padding: "12px 20px",
            background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
            borderLeft: "4px solid #2d3748",
            borderRadius: "0 8px 8px 0",
            boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
            display: "flex",
            alignItems: "flex-start",
            gap: "10px",
        }}>
            {/* Icon */}
            <span style={{
                marginTop: "2px",
                flexShrink: 0,
                width: "20px",
                height: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2d3748" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="12" />
                    <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
            </span>

            {/* Text */}
            <p style={{
                margin: 0,
                fontSize: "13px",
                fontWeight: "500",
                color: "#4a5568",
                lineHeight: "1.6",
                textAlign: "justify",
            }}>
                {data}
            </p>
        </div>
    );
}

export default DescriptionList